<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import { useSidebarStore } from '@/store/sidebars'
const { open, expanded } = storeToRefs(useSidebarStore())

import IconOwner from '@/components/Icon/Owner.vue'
import IconClose from '@/components/Icon/Close.vue'
</script>

<template>
  <IconClose v-if="expanded" class="size-6 p-1.5 text-tt-dark" />
  <IconOwner v-else class="size-6 text-tt-dark" />
</template>
